import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import CrudMutateSliceModel, {
  CrudUpdateModel,
} from "../../../../general/infrastructure/slices/crudMutateSlice/crudMutateSliceModel";
import { GraphQLClient } from "../../../../../shared/gql-client";
import CrudService from "../../../../general/crudGraphql/infrastructure/services/crudGraphqlService";
import { z } from "zod";
import { PackingSlipModel } from "../../../dailyPlanning/domain/models/packingSlipModel";

const crudAPI = new CrudService();

const packingSlipFormSchema = z.object({
  id: z.number(),
  comment: z.string().optional().nullable(),
  relation_id: z.number(),
  date: z.string(),
  status: z.string(),
});

export const updatePackingSlip = createAsyncThunk(
  "crudUpdate/updatePackingSlip",
  async ({ id, data, mutation }: CrudUpdateModel, thunkAPI) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };
    const { crudMutate } = thunkAPI.getState() as {
      crudMutate: CrudMutateSliceModel;
    };

    const existingModel = crudMutate.model as PackingSlipModel;

    // Escape newlines and quotes in the comment
    const escapedData = {
      ...data,
      comment: (data as { comment?: string }).comment
        ?.replace(/\n/g, "\\n")
        .replace(/"/g, '\\"'),
    };

    crudAPI.init(client, packingSlipFormSchema);
    try {
      return await crudAPI.mutate(
        {
          id,
          date: existingModel.date,
          status: existingModel.status,
          relation_id: parseInt(existingModel.relation.id.toString()),
          ...escapedData,
        },
        mutation,
        [],
        [],
      );
    } catch (err) {
      console.error(err);
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const updatePackingSlipExtraReducers = (
  builder: ActionReducerMapBuilder<CrudMutateSliceModel>,
) => {
  builder.addCase(updatePackingSlip.fulfilled, (state, action) => {
    state.model = {
      ...state.model,
      comment: (action.payload as PackingSlipModel).comment,
      status: (action.payload as PackingSlipModel).status,
    };
  });
};
